export default {
  data(){
    return {
      loading: false,
      tableData: [],
      totalCount: 0,
    }
  },
  created(){
    this.dataType = this.$route.query.row.dataType;
    this.optId = this.$route.query.row.optId;
    this.getTableDataTwo()
  },
  methods: {
    /*获取表格数据*/
    getTableDataTwo() {
      this.loading = true;
      this.axios({
        method: "post",
        url: "/dataSource/sx/list/detail/detail",
        data: {
          dataType: this.dataType,
          optId: this.optId,
        },
      })
        .then((response) => {
          this.loading = false;
          if (response.data.success) {
            this.tableData = response.data.data.records.map((item)=>{
              return {
                item,
                ...item,
                gender: item.gender && item.gender == 0 ? "男" : "女",
                hasBadMedicalHistory:item.hasBadMedicalHistory && item.hasBadMedicalHistory
                == 0 ?" 否":"是",
                direction: item.direction && item.direction === 1 ? "入场" : "出场",
              }
            });
            console.log(2222, this.tableData);
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
}